// Optional per-city photos. Drop a JPEG into src/app/asset/cities/<slug>.jpg
// (lowercase city slug, matching the backend's `slug` column) and it becomes
// the card cover automatically. Cities without a file fall back to a stable
// per-slug gradient — see cityGradient() below.
const modules = import.meta.glob('/src/app/asset/cities/*.{jpg,jpeg,png,webp}', {
  eager: true,
  import: 'default',
}) as Record<string, string>;

const cityImageBySlug: Record<string, string> = {};
for (const [path, url] of Object.entries(modules)) {
  const filename = path.split('/').pop()?.split('.')[0]?.toLowerCase();
  if (filename) cityImageBySlug[filename] = url;
}

export function getCityImage(slug: string): string | null {
  return cityImageBySlug[slug.toLowerCase()] ?? null;
}

function hashString(input: string): number {
  let h = 0;
  for (let i = 0; i < input.length; i++) h = (h * 31 + input.charCodeAt(i)) | 0;
  return Math.abs(h);
}

/**
 * Stable two-stop gradient for cities without a photo. Looks like a stylised
 * travel poster — different per city, but always tasteful (mid-saturation,
 * darker tones so white text always reads on top).
 */
export function cityGradient(slug: string): string {
  const h = hashString(slug);
  const baseHue = h % 360;
  const accentHue = (baseHue + 40 + (h % 30)) % 360;
  return `linear-gradient(135deg,
    hsl(${baseHue}, 55%, 32%) 0%,
    hsl(${accentHue}, 60%, 22%) 100%)`;
}
